<template>
  <b-container fluid>
    <b-row>
     <b-col :lg="cols">
        <card>
          <TableActionHeader v-on:filterChange="onFilterChange" v-on:newItem="onNewItem"></TableActionHeader> 
          <OrganisationTable :filter="filter" v-on:selectItem="onSelectItem"></OrganisationTable>               
        </card>
      </b-col>
      <b-col>
        <InfoCard v-if="action == ''"></InfoCard>
        <card v-if="action == 'new'">
          <CardHeader :title="$t('item.new')" />
          <OrganisationForm :item="item" :action="action"></OrganisationForm>                  
        </card>
        <card v-if="action == 'edit'">
          <CardHeader :title="item ? item.nimi : ''" type="item" />
          <OrganisationForm :item="item" :action="action"></OrganisationForm>                  
        </card>
      </b-col>
     </b-row>
  </b-container>

</template>

<script>

import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import OrganisationTable from '@/components/System/OrganisationTable.vue'
import OrganisationForm from '@/components/System/OrganisationForm.vue'
import i18n from '@/i18n'

export default {
    name: 'Organisations',
    components: {
        OrganisationTable, OrganisationForm, TableActionHeader, CardHeader
    },
    data: function() {
        return {
            showForm: true,
            cols: 8,
            filter: null,
            item: {
                organisation: {
                    "id": null,
                    "name": null
                }
            },
            action: ""
        }
    },
    methods: {
        onFilterChange: function(filter) {
            this.filter = filter;
        },
        onNewItem: function() {
            this.item = {
                organisation: {
                    "id": null,
                    "name": null
                }
            };        
            this.action = "new";         
        },
        onSelectItem: function(item) { 
            if (item)
                this.item = JSON.parse(JSON.stringify(item));  
            this.action = "edit"         
        },
        onClose(){
            this.action = "";         
        },
    },
    computed: {
        formTitle(){
            return i18n.t('item.' + this.action);
        }
    }
}
</script>